import { createFileRoute } from '@tanstack/react-router';
import ApiDemoPage from '@/features/widget-demo/ApiDemoPage';

export const Route = createFileRoute('/shops/api-docs')({
  component: ApiDemoPage,
});
